var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useCallback, useRef } from "react";
function InputAuto(_a) {
    var label = _a.label, pholder = _a.pholder, data = _a.data, onSelected = _a.onSelected, onChange = _a.onChange, register = _a.register, name = _a.name, setValue = _a.setValue, clearErrors = _a.clearErrors, externalError = _a.error, _b = _a.showInfo, showInfo = _b === void 0 ? true : _b, defaultValue = _a.defaultValue;
    var _c = useState([]), suggestions = _c[0], setSugesstions = _c[1];
    var _d = useState(true), isHideSuggs = _d[0], setIsHideSuggs = _d[1];
    var _e = useState(""), selectedVal = _e[0], setSelectedVal = _e[1];
    var _f = useState(false), hasSelected = _f[0], setHasSelected = _f[1];
    var _g = useState(null), error = _g[0], setError = _g[1];
    var inputRef = useRef(null);
    useEffect(function () {
        if (defaultValue != null && data.length > 0) {
            var defaultItem = data.find(function (item) { return item.id === defaultValue; });
            if (defaultItem) {
                setSelectedVal(defaultItem.name);
                setHasSelected(true);
                if (setValue) {
                    setValue(name, defaultItem.id);
                }
            }
        }
    }, [defaultValue, data, name, setValue]);
    var filterSuggestions = function (value) {
        if (value.length < 2) {
            setIsHideSuggs(true);
            setSugesstions([]);
            return;
        }
        var filtered = data.filter(function (i) {
            return i.name.toLocaleLowerCase('tr-TR').includes(value.toLocaleLowerCase('tr-TR'));
        });
        setSugesstions(filtered);
        setIsHideSuggs(filtered.length === 0);
    };
    var handleChange = function (e) {
        var input = e.target.value;
        setSelectedVal(input);
        setHasSelected(false);
        filterSuggestions(input);
        if (clearErrors) {
            clearErrors(name);
        }
        if (onChange) {
            onChange(input);
        }
        if (setValue) {
            setValue(name, null);
        }
    };
    var selectSuggestion = function (value) {
        if (onSelected) {
            onSelected(value);
        }
        setSelectedVal(value.name);
        setHasSelected(true);
        setIsHideSuggs(true);
        if (setValue) {
            setValue(name, value.id);
        }
    };
    var handleKeyDown = function (e) {
        if (!isHideSuggs && suggestions.length > 0) {
            if (e.key === "Escape") {
                setIsHideSuggs(true);
            }
        }
    };
    var handleBlur = function (e) {
        setTimeout(function () {
            var exactMatch = data.find(function (item) {
                return item.name.toLocaleLowerCase('tr-TR') === selectedVal.toLocaleLowerCase('tr-TR');
            });
            if (exactMatch) {
                selectSuggestion(exactMatch);
            }
            setIsHideSuggs(true);
        }, 200);
    };
    var handleFocus = function (e) {
        if (e.target.value.length >= 2) {
            filterSuggestions(e.target.value);
        }
    };
    var checkValue = useCallback(function () {
        if (!hasSelected && selectedVal.length > 0) {
            setError("Listeden meslek seçimi yapınız.");
        }
        else {
            setError(null);
        }
    }, [selectedVal, hasSelected]);
    useEffect(function () {
        checkValue();
    }, [selectedVal, checkValue]);
    return (_jsxs("div", __assign({ className: "sugesstion-auto" }, { children: [_jsxs("div", __assign({ className: "form-control-auto" }, { children: [_jsxs("label", __assign({ htmlFor: name || "tag-input" }, { children: [label, showInfo && _jsxs("span", __assign({ className: "fw-bold nowrap-ellipsis tooltip inline-block mx-2" }, { children: ["?", _jsx("div", __assign({ className: "tooltip-text" }, { children: "Meslek bilginizi se\u00E7ebilmeniz i\u00E7in mesle\u011Finizin ilk iki harfini yazman\u0131z gerekmektedir. Baz\u0131 meslekler ayn\u0131 anlama gelen farkl\u0131 ifadelerle tan\u0131mlanabildi\u011Finden, meslek listesinin a\u00E7\u0131lmamas\u0131 h\u00E2linde mesle\u011Finizi farkl\u0131 bir ifade ile aratmay\u0131 deneyebilirsiniz." }))] }))] })), _jsx("input", __assign({}, (register ? register(name, {
                        required: "Bu alan zorunludur",
                        validate: function (value) {
                            if (!value && value !== 0)
                                return "Bu alan zorunludur";
                            return true;
                        }
                    }) : {}), { id: name || "profession", ref: inputRef, autoComplete: "off", placeholder: pholder, type: "search", className: "form-control ".concat(error || externalError ? "border-danger" : ""), value: selectedVal, onChange: handleChange, onKeyDown: handleKeyDown, onFocus: handleFocus, onBlur: handleBlur })), (error || externalError) && (_jsx("div", __assign({ className: "text-danger" }, { children: error || (typeof externalError === 'string' ? externalError : externalError === null || externalError === void 0 ? void 0 : externalError.message) })))] })), _jsx("div", __assign({ className: "suggestions", style: { display: isHideSuggs ? "none" : "block" } }, { children: suggestions.map(function (item, idx) { return (_jsx("div", __assign({ onClick: function () {
                        selectSuggestion(item);
                    } }, { children: item.name }), "" + item.id + idx)); }) }))] })));
}
export default InputAuto;
